<template>
  <div class="live-reward-setting">
    <div class="reward-form">
      <div class="reward-form_tab">
        <div class="tab-title">
          {{ $t('host.k_573001') }}
        </div>
        <div class="tab-item">
          <vh-radio v-model="rewardMode" :label="1">{{ $t('host.k_573002') }}</vh-radio>
          <vh-radio v-model="rewardMode" :label="2">{{ $t('host.k_573003') }}</vh-radio>
          <vh-radio v-model="rewardMode" :label="3">{{ $t('host.k_573004') }}</vh-radio>
          <vh-radio v-model="rewardMode" :label="4">{{ $t('host.k_573005') }}</vh-radio>
        </div>
      </div>
      <!-- 寄送奖品 -->
      <vh-form :model="rewardForm" ref="ruleForm" label-width="100px" v-if="rewardMode == 1">
        <vh-form-item
          v-for="(item, index) in rewardList"
          :key="index"
          :label="$t(item.field)"
          :ref="`${item.field_key}`"
        >
          <vh-input
            v-model="rewardForm[item.field_key]"
            type="text"
            :maxlength="awardLimitNum[item.rank > 3 ? 3 : item.rank - 1]"
            :placeholder="$t(item.placeholder)"
          ></vh-input>
          <div class="reward-form_delete">
            <i
              class="vh-iconfont vh-line-delete"
              style="margin-right: 10px"
              @click="deleteRewardPrize(index)"
              v-if="!Boolean(item.is_system)"
            ></i>
            <p class="reward-form_switch" v-if="index > 0">
              <template v-if="item.field_key === 'phone'">
                <vh-switch
                  v-model="item.is_check"
                  :inactive-text="$t('host.k_573006')"
                  :active-value="1"
                  :inactive-value="0"
                  @change="handlePhoneCheckChange"
                  style="margin-right: 15px"
                ></vh-switch>
              </template>
              <vh-switch
                v-model="item.is_required"
                active-color="#fb3a32"
                inactive-color="#cecece"
                :inactive-text="$t('host.k_573007')"
              ></vh-switch>
            </p>
          </div>
        </vh-form-item>
        <div class="reward-form_add" @click="addField" v-if="rewardList.length < 6">
          <i class="vh-icon-plus"></i>
          {{ $t('host.k_573008') }}
        </div>
        <vh-form-item :label="$t('host.k_573009')">
          <vh-switch
            v-model="compulsory_award"
            :active-value="1"
            :inactive-value="0"
            :active-text="$t('host.k_573010')"
          ></vh-switch>
        </vh-form-item>
        <vh-form-item :label="$t('host.k_573011')">
          <ComplianceChoice
            ref="complianceChoice"
            v-model="privacyStatementData"
            @change="complianceChange"
          ></ComplianceChoice>
        </vh-form-item>
      </vh-form>

      <!-- 私信兑奖 -->
      <vh-form
        :model="rewardModeForm"
        label-width="100px"
        onsubmit="return false;"
        v-if="rewardMode == 2"
      >
        <vh-form-item :label="$t('host.k_573012')">
          <vh-input v-model="rewardModeForm.private_number" autocomplete="off"></vh-input>
        </vh-form-item>
        <vh-form-item :label="$t('host.k_573013')">
          <vh-upload
            :headers="headersVo"
            class="reward-form_upload"
            :action="action"
            :show-file-list="false"
            name="resfile"
            :before-upload="beforeUpload"
            :data="{
              path: `${roomId}/img`,
              type: 'image',
              interact_token: interactToken
            }"
            accept=".jpg, .jpeg, .png, .bmp"
            :on-success="uploadSuccess"
          >
            <div class="reward_box" v-if="rewardModeForm.private_qrcode">
              <div class="reward-picture">
                <img :src="rewardModeForm.private_qrcode" alt="" />
              </div>
              <div class="reward-view">
                <span>
                  <i class="vh-iconfont vh-a-line-counterclockwiserotation"></i>
                  <br />
                  {{ $t('host.k_573014') }}
                </span>
                <span @click.stop.prevent="deleteImg">
                  <i class="vh-iconfont vh-line-delete"></i>
                  <br />
                  {{ $t('host.k_573015') }}
                </span>
              </div>
            </div>
            <div class="reward-plus" v-else>
              <span><i class="vh-iconfont vh-a-line-cloudtoupload"></i></span>
              <p>{{ $t('host.k_573016') }}</p>
              <p>{{ $t('host.k_573017') }}</p>
            </div>
          </vh-upload>
        </vh-form-item>
        <vh-form-item :label="$t('host.k_573018')">
          <vh-input
            v-model="rewardModeForm.tip_note"
            :maxlength="20"
            autocomplete="off"
            show-word-limit
            :placeholder="$t('host.k_573019')"
          ></vh-input>
          <p class="award_tip">{{ $t('host.k_573020') }}</p>
        </vh-form-item>
      </vh-form>

      <!-- 无需领奖 -->
      <div class="reward-form_null" v-if="rewardMode == 3">
        <div class="reward-form_wrapper">
          <span><img src="../../img/no-null.png" alt="" /></span>
          <p>{{ $t('host.k_573021') }}</p>
        </div>
      </div>
      <vh-form
        v-if="rewardMode == 4"
        :model="customPrizeForm"
        ref="customPrizeForm"
        :rules="customPrizeFormRules"
        label-width="80px"
      >
        <vh-form-item :label="$t('host.k_573022')">
          <vh-input
            :placeholder="$t('host.k_573023')"
            :maxlength="15"
            show-word-limit
            v-model="customPrizeForm.custom_btn_txt"
          ></vh-input>
        </vh-form-item>
        <vh-form-item :label="$t('host.k_573024')" prop="custom_link">
          <vh-input
            :placeholder="$t('host.k_573025')"
            v-model="customPrizeForm.custom_link"
          ></vh-input>
        </vh-form-item>
        <vh-form-item>
          <p class="notice_txt">
            {{ $t('host.k_573026') }}
            <br />
            {{ $t('host.k_573027') }}
            <br />
            {{ $t('host.k_573028') }}
          </p>
        </vh-form-item>
      </vh-form>
      <div class="reward-form_btn">
        <!-- <vh-button
        size="medium"
        round
        class="transparent-btn"
        @click="returnStep('list')"
        v-preventReClick
      >
        返回列表
      </vh-button>
      <vh-button size="medium" v-preventReClick @click="returnStep('condition')" round>
        上一步
      </vh-button> -->
        <vh-button
          type="primary"
          :disabled="isDisabled"
          round
          @click="sureRewardPrize"
          v-preventReClick
        >
          {{ $t('host.k_573029') }}
        </vh-button>
      </div>
    </div>
    <div class="reward-preview">
      <div class="reward-preview_mask">
        <!-- 寄送奖品预览 -->
        <div class="reward-preview_accept way1" v-if="rewardMode == 1">
          <div v-if="compulsory_award == 0" class="has-close"></div>
          <div class="reward-container">
            <div class="reward-container_form">
              <vh-form :model="rewardForm">
                <vh-form-item v-for="(item, index) in rewardList" :key="index" class="reward-item">
                  <span class="red" v-if="item.is_required == 1">*</span>
                  <vh-input
                    v-model="rewardForm[item.field_key]"
                    readonly
                    type="text"
                    :placeholder="item.placeholder"
                  ></vh-input>
                </vh-form-item>
              </vh-form>
            </div>
          </div>
          <div class="reward-container_btn">{{ $t('host.k_573030') }}</div>
          <!-- 隐私合规（嵌入不展示） -->
          <div class="privacy-preview" v-html="privacyHtm"></div>
        </div>
        <!-- 私信兑奖预览 -->
        <div class="reward-preview_accept way2" v-else-if="rewardMode == 2">
          <div class="reward-container">
            <div class="reward-container_service">
              <div>
                <p class="service-title" v-if="rewardModeForm.private_number">
                  {{ rewardModeForm.private_number }}
                </p>
                <div class="reward-service" v-if="rewardModeForm.private_qrcode">
                  <img :src="rewardModeForm.private_qrcode" alt="" />
                </div>
                <p class="service-title" v-if="rewardModeForm.tip_note">
                  {{ rewardModeForm.tip_note }}
                </p>
              </div>
            </div>
          </div>
        </div>

        <!-- 无需领奖预览 -->
        <div class="reward-preview_no" v-else-if="rewardMode == 3">
          <img src="../../img/no-award.png" alt="" />
        </div>
        <div class="reward-preview_custom" v-else-if="rewardMode == 4">
          <img src="../../img/custom_preview.png" alt="" />
          <a :href="customPrizeForm.custom_link" target="_blank">
            {{ customPrizeForm.custom_btn_txt }}
          </a>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import to from 'await-to-js';
  import { useRoomBaseServer, useLotteryServer, usePrivacyAgreementServer } from 'middle-domain';
  import ComplianceChoice from './privacy-compliance/ComplianceChoice.vue';

  export default {
    components: {
      ComplianceChoice
    },
    data() {
      return {
        rewardMode: 1,
        rewardModeForm: {
          private_number: '',
          private_qrcode: '',
          tip_note: this.$t('host.k_573031')
        },
        rewardForm: {
          name: '',
          phone: '',
          address: '',
          user_define_100: '',
          user_define_101: '',
          user_define_102: '',
          placeholder: ''
        },
        compulsory_award: 0,
        index: 0,
        lotteryRank: 0, // 领奖页信息---最后一条的rank值
        action: `${process.env.VUE_APP_BASE_URL}/v3/commons/upload/index`,
        awardLimitNum: [20, 20, 50, 100],
        rewardList: [
          {
            is_system: 1,
            field: this.$t('host.k_573032'),
            field_key: 'name',
            is_required: true,
            placeholder: this.$t('host.k_573033'),
            rank: 1
          },
          {
            is_system: 1,
            field: this.$t('host.k_573034'),
            field_key: 'phone',
            is_required: true,
            is_check: 1,
            placeholder: this.$t('host.k_573035'),
            rank: 2
          },
          {
            is_system: 1,
            field: this.$t('host.k_573036'),
            field_key: 'address',
            is_required: false,
            placeholder: this.$t('host.k_573037'),
            rank: 3
          }
        ],

        awardModeList: [
          {
            placeholder: '',
            field: this.$t('host.k_573012'),
            field_key: 'private_number',
            is_required: false,
            is_system: 1,
            rank: 1
          },
          {
            placeholder: '',
            field: this.$t('host.k_573013'),
            field_key: 'private_qrcode',
            is_required: false,
            is_system: 1,
            rank: 2
          },
          {
            placeholder: this.$t('host.k_573038'),
            field: this.$t('host.k_573018'),
            field_key: 'tip_note',
            is_required: true,
            is_system: 1,
            rank: 3
          }
        ],

        // 隐私协议相关数据
        privacyStatementData: {
          statement_status: 0, //默认用系统自带协议
          statement_content: '',
          statement_info: []
        },
        privacyHtm: '',
        customPrizeForm: {
          custom_btn_txt: this.$t('host.k_573023'),
          custom_link: ''
        },
        customPrizeFormRules: {
          custom_link: [
            { required: true, message: this.$t('host.k_573039'), trigger: 'blur' },
            {
              pattern: /(https):\/\/[\w\-_]+(\.[\w\-_]+).*?/,
              message: this.$t('host.k_573040'),
              trigger: 'blur'
            }
          ]
        }
      };
    },
    computed: {
      // 当前用户角色 1-主持人 2-观众(发起端没有观众) 3-助理；4-嘉宾（互动直播才有嘉宾）
      roleName() {
        return this.roomBaseServer.state.watchInitData.join_info.role_name;
      },
      headersVo: function () {
        const vo = {
          // 助理&嘉宾端不传token
          token: this.roleName == 3 || this.roleName == 4 ? '' : this.headToken,
          platform: 7,
          'gray-id': this.grayId
        };
        return vo;
      },
      lotteryId() {
        return this.lotteryServer.state.lotteryLiveId;
      },
      isDisabled() {
        return (
          this.rewardMode == 2 &&
          !(this.rewardModeForm.private_qrcode || this.rewardModeForm.private_number)
        );
      }
    },
    beforeCreate() {
      this.lotteryServer = useLotteryServer({
        mode: 'live'
      });
      this.privacyAgreementServer = usePrivacyAgreementServer();
      this.roomBaseServer = useRoomBaseServer();
    },
    created() {
      const { watchInitData } = useRoomBaseServer().state;
      this.roomId = watchInitData?.interact?.room_id;
      this.interactToken = watchInitData?.interact?.interact_token;
      this.headToken = localStorage.getItem('token');
    },
    mounted() {
      // this.initComponent();
    },
    methods: {
      initComponent() {
        if (this.lotteryId) {
          this.getRewardInfo();
        }
      },
      // 返回列表
      returnStep(name) {
        this.$emit('returnStep', name);
      },
      deleteImg() {
        this.rewardModeForm.private_qrcode = '';
      },
      beforeUpload(file) {
        const typeList = ['jpg', 'png', 'jpeg', 'bmp'];
        let typeArr = file.type.toLowerCase().split('/');
        const isType = typeList.includes(typeArr[typeArr.length - 1]);
        const isLt2M = file.size / 1024 / 1024 < 2;
        if (!isType) {
          this.$message.warning(this.$t('host.k_573041'));
          return false;
        }
        if (!isLt2M) {
          this.$message.warning(this.$t('other.other_1004'));
          return false;
        }
        return isType && isLt2M;
      },
      uploadSuccess(res, file) {
        console.log(res, file);
        if (res.code === 200) {
          this.rewardModeForm.private_qrcode = res.data.domain_url;
        } else {
          this.$message.error(this.$tec(res.code), this.$t('host.k_573042'));
        }
      },
      addField() {
        if (this.rewardList.length == 6) {
          this.$message.error(this.$t('host.k_573043'));
          return false;
        }
        this.index++;
        this.rewardList.push({
          is_system: 0,
          field: this.$t('host.k_573044', [this.index]),
          field_key: 'user_define_' + (this.rewardList.length + 97),
          is_required: false,
          placeholder: this.$t('host.k_573045'),
          rank: this.rewardList.length + 97
        });
      },
      // 获取领奖信息
      getRewardInfo() {
        this.lotteryServer.getLiveAwardInfo(this.lotteryId).then(res => {
          if (res.code === 200) {
            this.rewardMode = res.data.receive_award_way;
            this.compulsory_award =
              (res.data.compulsory_award && parseInt(res.data.compulsory_award + '')) || 0;
            let list = JSON.parse(res.data.json_data);
            if (res.data.receive_award_way == 1) {
              this.lotteryRank = list[list.length - 1].rank;
              this.rewardList = list;
              this.rewardList.forEach(ele => {
                this.rewardForm[ele.field_key] = ele.placeholder;
              });
              this.rewardList.map(item => {
                item.is_required = Boolean(item.is_required);
              });
            } else if (res.data.receive_award_way == 2) {
              this.awardModeList = list;
              this.lotteryRank = 0;
              this.awardModeList.forEach(ele => {
                this.rewardModeForm[ele.field_key] = ele.placeholder;
              });
            } else if (res.data.receive_award_way == 4) {
              this.customPrizeForm = list[0];
            }
          }
        });
        // 获取隐私协议数据
        this.getPrivacyAgreement();
      },
      // 获取隐私协议数据
      async getPrivacyAgreement() {
        const [err, res] = await to(
          this.privacyAgreementServer.getPrivacyAgreement(2, this.lotteryId)
        );
        if (err || !res || res.code != 200) {
          // this.$message.error(err.msg || res?.msg || '请求出现异常');
          return false;
        }
        this.privacyStatementData = {
          statement_status: res.data.statement_status,
          statement_content: res.data.statement_content || '',
          statement_info: res.data.statement_info || []
        };
      },
      // 保存隐私协议
      async savePrivacyAgreement() {
        if (this.privacyStatementData.statement_status === 1) {
          // 自定义协议时的校验
          if (
            !this.privacyStatementData.statement_content ||
            !Array.isArray(this.privacyStatementData.statement_info) ||
            this.privacyStatementData.statement_info.length === 0
          ) {
            this.$message.error(this.$t('host.k_573046'));
            return false;
          }
          const hasEmpty = this.privacyStatementData.statement_info.some(item => {
            return !item.title || !item.link;
          });
          if (hasEmpty) {
            this.$message.error(this.$t('host.k_573046'));
            return false;
          }
        }
        const params = {
          module: 2,
          source_id: this.lotteryId,
          ...this.privacyStatementData
        };
        if (Array.isArray(params.statement_info)) {
          // 保存提交的时候用字符串
          params.statement_info = JSON.stringify(params.statement_info);
        }
        const [err, res] = await to(this.privacyAgreementServer.savePrivacyAgreement(params));
        if (err || !res || res.code != 200) {
          return false;
        }
        return true;
      },
      // 保存
      async sureRewardPrize() {
        if (this.rewardMode == 1) {
          // 保存隐私协议
          const isOk = await this.savePrivacyAgreement();
          if (!isOk) return;
        }
        let params = {
          receive_award_way: this.rewardMode,
          compulsory_award: this.compulsory_award
        };
        if (this.rewardMode == 1) {
          this.rewardList.forEach(ele => {
            ele.placeholder = this.rewardForm[ele.field_key];
          });
          params.data = JSON.stringify(this.rewardList);
        } else if (this.rewardMode == 2) {
          this.awardModeList.forEach(ele => {
            ele.placeholder = this.rewardModeForm[ele.field_key];
          });
          params.data = JSON.stringify(this.awardModeList);
        } else if (this.rewardMode == 4) {
          const isValid = await this.$refs.customPrizeForm.validate();
          if (!isValid) return;
          params.data = JSON.stringify([this.customPrizeForm]);
        }

        this.lotteryServer
          .saveLiveAwardInfo(params)
          .then(res => {
            if (res.code === 200) {
              this.$message.success(this.$t('host.k_573047'));
              this.lotteryRank = 0;
              this.$emit('success', { type: 'reward', act: 'save' });
              // this.returnStep('prize');
            } else {
              this.$message.error(res.msg);
            }
          })
          .catch(e => {
            this.$message.error(e.msg);
          });
      },
      deleteRewardPrize(index) {
        this.rewardList.splice(index, 1);
      },
      // 隐私协议变更
      complianceChange({ privacyHtm }) {
        this.privacyHtm = privacyHtm;
      },
      async handlePhoneCheckChange(val) {
        if (!val) {
          const confirm = await this.$vhConfirm(
            this.$t('host.k_573048'),
            this.$t('host.k_573026'),

            {
              roundButton: true,
              confirmButtonText: this.$t('host.k_573049'),
              cancelButtonText: this.$t('host.k_573050'),
              lockScroll: false,
              closeOnClickModal: false,
              closeOnPressEscape: false
            }
          ).catch(() => false);
          if (!confirm) {
            // 暂不关闭, 把开关状态还原回去
            for (const item of this.rewardList) {
              if (item.field_key === 'phone') {
                item.is_check = 1;
                break;
              }
            }
          }
        }
      }
    }
  };
</script>
<style lang="less">
  .live-reward-setting {
    display: flex;
    position: relative;
    min-height: 500px;

    .reward-form {
      width: 490px;
      margin-right: 80px;

      .vh-form {
        position: relative;
      }

      .vh-form-item__label {
        color: #1a1a1a;
      }

      &_tab {
        display: flex;
        padding: 12px 0;
        height: 36px;

        .vh-radio,
        .vh-radio__input.is-checked + .vh-radio__label {
          color: #1a1a1a;
        }

        .vh-radio__label {
          color: rgba(0, 0, 0, 0.65);
        }

        .tab-title {
          width: 88px;
          line-height: 16px;
          font-size: 14px;
          text-align: right;
          padding-right: 12px;
          color: #1a1a1a;

          &_color {
            color: #fb3a32;
          }
        }

        .tab-item {
          // width: calc(100% - 100px);
          display: flex;
        }
      }

      &_upload {
        .vh-upload {
          width: 100%;
          height: 120px;
          line-height: unset;
          overflow: hidden;
          background-color: #f7f7f7;
          border: 1px solid #ccc;
          border-radius: 4px;
        }

        .reward_box {
          width: 100%;
          height: 100%;
          display: table;
          position: relative;

          &:hover {
            .reward-view {
              display: flex;
              justify-content: center;
              align-items: center;
              color: #fff;
              line-height: 20px;
            }
          }
        }

        .reward-picture {
          width: 231px;
          height: 120px;
          margin: 0 auto;

          img {
            width: 100%;
            height: 100%;
            object-fit: scale-down;
          }
        }

        .reward-view {
          position: absolute;
          width: 100%;
          height: 100%;
          left: 0;
          top: 0;
          background: rgba(#000, 0.7);
          display: none;

          span {
            font-size: 12px;
            color: #fff;
            padding: 0 8px;
          }
        }

        .reward-plus {
          width: 100%;
          height: 100%;
          position: relative;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;

          span {
            i {
              font-size: 36px;
              color: #999;
            }
          }

          p {
            color: #999;
            font-size: 14px;
            line-height: 20px;
          }
        }
      }

      &_delete {
        float: right;
        height: 20px;

        i {
          font-size: 14px;
          cursor: pointer;
          vertical-align: middle;
        }
      }

      &_switch {
        display: inline-block;

        .switch_title {
          padding: 0 5px;
          color: #1a1a1a;
          vertical-align: middle;
        }
      }

      &_add {
        margin-left: 100px;
        margin-bottom: 10px;
        font-size: 14px;
        color: #3562fa;
        cursor: pointer;

        i {
          color: #3562fa;
        }
      }

      .vh-button {
        margin-top: 24px;
      }

      &_btn {
        // margin-top: 50px;
        margin-left: 100px;
      }

      &_null {
        width: 380px;
        height: 320px;
        background: rgba(0, 0, 0, 0.02);
        border-radius: 8px;
        margin-left: 100px;
      }

      &_wrapper {
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;

        span {
          width: 120px;
          height: 130px;
          display: inline-block;

          img {
            width: 100%;
            height: 100%;
            object-fit: cover;
          }
        }

        p {
          line-height: 20px;
          margin-top: 12px;
          font-size: 14px;
          text-align: center;
          color: rgba(0, 0, 0, 0.65);
        }
      }

      .award_tip {
        margin-top: 12px;
        font-size: 12px;
        color: #999;
        line-height: 22px;
        white-space: normal;
        word-break: break-word;
        overflow-wrap: break-word;
      }
      .notice_txt {
        font-size: 12px;
        line-height: 24px;
        white-space: normal;
        word-break: break-word;
        overflow-wrap: break-word;
      }
    }

    .reward-preview {
      width: 280px;
      height: 503px;
      background-image: url('../../img/prize.png');
      background-size: cover;
      margin-top: -25px;
      position: relative;

      &_mask {
        position: absolute;
        top: 65px;
        left: 35px;
        width: 230px;
        height: 410px;
        background: rgba(0, 0, 0, 0.7);
        border-radius: 0 0 24px 24px;
      }

      &_no {
        width: 176px;
        height: 210px;
        margin: 0 auto;
        margin-top: 98px;

        img {
          width: 100%;
          height: 100%;
          object-fit: scale-down;
        }
      }

      &_accept {
        margin: auto;
        margin-top: 176px;
        width: 233px;
        height: 240px;
        margin-left: -1px;
        background-image: url(../../img/accept-review.png);
        background-size: 100%;
        border-radius: 0 0 24px 24px;

        .reward-container {
          padding-top: 45px;

          &_form {
            text-align: center;
            margin: 10px auto;
            height: 130px;
            padding: 0 16px;
            overflow-y: auto;

            p {
              margin-top: 24px;
            }

            .red {
              position: absolute;
              left: 0px;
              top: 2px;
              display: inline-block;
              color: #fe6a6a;
              margin-right: 10px;
            }

            .reward-item {
              padding-left: 15px;
              background: #fff;
              border-radius: 4px;
              margin-bottom: 9px;

              input {
                border: 0;
                color: #bfbfbf;
              }
            }

            &::-webkit-scrollbar {
              display: none;
            }
          }

          &_btn {
            width: 190px;
            margin: auto;
            text-align: center;
            color: #fff;
            background: #fb3a32;
            height: 30px;
            line-height: 30px;
            border-radius: 20px;
            cursor: pointer;
          }

          &_service {
            text-align: center;
            width: 170px;
            height: 165px;
            background: #fff;
            border-radius: 4px;
            margin: 10px auto;
            padding: 0 16px;
            display: flex;
            align-items: center;
            justify-content: center;

            .reward-service {
              width: 80px;
              height: 80px;
              margin: 0 auto;
              margin-bottom: 5px;

              img {
                width: 100%;
                height: 100%;
                object-fit: scale-down;
              }
            }

            .service-title {
              width: 170px;
              white-space: nowrap;
              text-overflow: ellipsis;
              overflow: hidden;
              font-size: 14px;
              line-height: 32px;
              height: 32px;
              text-align: center;
              // padding-top: 5px;
              color: rgba(0, 0, 0, 0.85);
            }
          }
        }
      }
      &_custom {
        height: 100%;
        width: 100%;
        border-radius: 0 0 20px 20px;
        overflow: hidden;
        position: relative;
        img {
          width: 100%;
          height: 100%;
        }
        a {
          position: absolute;
          display: block;
          background: #fb2626;
          font-size: 10px;
          min-width: 80px;
          border-radius: 30px;
          padding: 7px 10px;
          color: #fff;
          bottom: 116px;
          left: 50%;
          transform: translateX(-50%);
          text-align: center;
          white-space: nowrap;
        }
      }

      .reward-preview_accept.way1 {
        position: absolute;
        margin: auto;
        width: 233px;
        height: auto;
        left: 0;
        right: 0;
        bottom: 0;
        margin-left: -1px;
        background-image: url(../../img/accept-review-noclose.png);
        background-repeat: no-repeat;
        background-size: 100%;
        border-radius: 0 0 24px 24px;

        .has-close {
          position: absolute;
          top: 15px;
          right: 14px;

          &:after {
            content: '\00D7';
            font-size: 18px;
            font-weight: normal;
            color: #ffce70;
          }
        }

        .privacy-preview {
          display: block;
          position: relative;
          z-index: 2;
          font-size: 12px;
          padding: 10px 15px;
          line-height: 1.5;
          background: linear-gradient(37.94deg, #fffbe8 3.86%, #fbf0e6 84.36%);

          a {
            font-style: normal;
            font-weight: 400;
            font-size: 12px;
            line-height: 1.5;
            word-break: break-word;
            text-decoration: none;
            font-weight: 400;
            color: #3562fa;
            transform: matrix(0.99, 0, -0.14, 1, 0, 0);

            &:hover {
              color: #3562fa;
            }
          }
        }
      }
    }
  }
</style>
